import { render, staticRenderFns } from "./SewageTankAlarm.vue?vue&type=template&id=5061e66e&scoped=true&"
import script from "./SewageTankAlarm.vue?vue&type=script&lang=js&"
export * from "./SewageTankAlarm.vue?vue&type=script&lang=js&"
import style0 from "./SewageTankAlarm.vue?vue&type=style&index=0&id=5061e66e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5061e66e",
  null
  
)

export default component.exports